module.exports = __webpack_public_path__ + "81fb63968aaa4cef57d05081986e6a50.png";